import { P2TextLabel } from 'react-bootstrap-common-script';
import { useAppSelector } from '../../../../redux/hook';
import { uniqBy } from 'lodash';
import { useGetApplicationHdbRefQuery } from '../../../../redux/services/getStageE';

type Step2SummarySegmentProps = {
  selectedCpfFormSN: string[];
  cpfAccountNumber: string;
  loginUserUinfin: string;
  applicationId: string;
  singpassToken: string;
};

function Step2SummarySegment({ selectedCpfFormSN, cpfAccountNumber, loginUserUinfin, applicationId, singpassToken }: Step2SummarySegmentProps) {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const applicationStep1 = useAppSelector((state) => state.app.ApplicationStep1Slice.formData);

  const { data: applicationHdbRefData } = useGetApplicationHdbRefQuery(
    {
      application_id: applicationId,
      uinfin: loginUserUinfin,
      singpass_token: singpassToken,
    },
    { skip: applicationId === '0' || applicationId === null }
  );

  // Find Cpf account name from all owners
  const owners = applicationStep1?.household?.owners ?? [];
  const incomingOwners = applicationStep1?.household?.incoming_owners ?? [];
  const allOwners = [...owners, ...incomingOwners];

  // Deduplicate by uinfin
  const uniqueOwners = uniqBy(allOwners, (owner) => owner.myinfo.uinfin);

  // Find the matching owner
  const cpfAccountOwner = cpfAccountNumber
    ? uniqueOwners.find((owner) => owner.myinfo.uinfin === cpfAccountNumber)
    : uniqueOwners.find((owner) => owner.myinfo.uinfin === loginUserUinfin);

  const cpfAccountName = cpfAccountOwner?.myinfo?.name ?? '';

  return (
    <div className='address-container'>
      <div className='address-box'>
        <div className='title'>
          <P2TextLabel label={'CPF Account No.'} />
        </div>
        <div className='content'>
          <p>{cpfAccountNumber || loginUserUinfin}</p>
        </div>
      </div>
      <div className='address-box'>
        <div className='title'>
          <P2TextLabel label={'Name'} />
        </div>
        <div className='content'>
          <p>{cpfAccountName}</p>
        </div>
      </div>
      <div className='address-box'>
        <div className='title'>
          <P2TextLabel label={'Flat Address'} />
        </div>
        <div className='content'>
          <p>{startApplicationFormData?.selected_hdb_property?.address}</p>
        </div>
      </div>
      <div className='address-box'>
        <div className='title'>
          <P2TextLabel label={'HDB Reference No.'} />
        </div>
        <div className='content'>
          <p>{applicationHdbRefData?.proposed_hdb_ref}</p>
        </div>
      </div>
      <div className='address-box'>
        <div className='title'>
          <P2TextLabel label={'CPF Withdrawal Form No.'} />
        </div>
        <div className='content'>
          <p>{selectedCpfFormSN?.join(' AND ')}</p>
        </div>
      </div>
    </div>
  );
}

export default Step2SummarySegment;
